module.exports = __webpack_public_path__ + "static/media/InshellPeanut.739d0951.pdf";